import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Observable }     from '../../../node_modules/rxjs/Observable';
import { Driver } from '../entities/driver';
import { Customer } from '../entities/customer';
import { Tracker } from '../entities/tracker';

import { SERVER_URL } from './server-url';
import { CollaboratorType } from '../entities/collaborator-type';

@Injectable()   
export class DriverService {
    private driverUrl = SERVER_URL + '/api/drivers';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/delivery';  // URL to web API
    
    public drivers:Array<Driver>;

    constructor (private http: Http) {}

    getDrivers(tokenLogged:string): Observable<Driver[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.driverUrl, {headers: headers})
                    .map(this.extractDriversFromJSON)
                    .catch(this.handleError);
    }
    
    private extractDriversFromJSON(res: Response | any) {
        let body = res.json();
        var driversList:Driver[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }

            var driver:Driver = new Driver(entry.id, entry.name, 
                                            entry.last_name, entry.cnh, 
                                            new Customer(entry.customer_id, null, null, null, null),
                                            new Tracker(entry.tracker_id, null, null, null, null, null, null),
                                            entry.dt_cnh, entry.dt_admission, entry.personal_phone, entry.coorp_phone,
                                            entry.address_street, 
                                            entry.address_number, 
                                            entry.address_complement, 
                                            entry.address_neighborhood,
                                            entry.address_city, 
                                            entry.address_state, 
                                            entry.address_country, 
                                            entry.address_zipcode, 
                                            entry.address_lat,
                                            entry.address_lng);
                
            driver.logisticCostKm = entry.logistic_cost_km;
            driver.logisticCostWeight = entry.logistic_cost_weight;

            var collaboratorType = new CollaboratorType(entry.collaborator_type_id, entry.collaborator_type_name);
            driver.collaboratorType = collaboratorType;

            driversList.push(driver);
        }
        return driversList;
    }

    getAllCollaboratorType(): Observable<CollaboratorType[]> {
        
        return this.http.get(this.driverUrl + '/types', null)
                    .map(this.extractCollaboratorTypeFromJSON)
                    .catch(this.handleError)
    }    


    private extractCollaboratorTypeFromJSON(res: Response | any) {
        let body = res.json();
        var collaboratorTypeList:CollaboratorType[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }

            var collaboratorType:CollaboratorType = new CollaboratorType(collaboratorType.id, collaboratorType.name);
            collaboratorTypeList.push(collaboratorType);
        }
        return collaboratorTypeList;
    }

    insertDriver(tokenLogged:string, driver:Driver): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.driverUrl + '/insert', driver, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    private resultInsert(res: Response | any) {
        let body = res.json();
        //console.log("retorno insert => " + body);
    }

    updateDriver(tokenLogged:string, driver:Driver): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.driverUrl + '/update', driver, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    getDriverById(tokenLogged:string, id:number): Observable<Driver> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.driverUrl + '/' + id, {headers: headers})
                    .map(this.extractDriverFromJSON)
                    .catch(this.handleError);
    }

    private extractDriverFromJSON(res: Response | any) {
        let body = res.json();
        let entry = body[0];
        //console.log('entry -> ' + entry);

        if (!entry.id) { return; }

        var cnhDate:Date = DriverService.generateDate(entry.dt_cnh);
        var admissionDate:Date = DriverService.generateDate(entry.dt_admission);

        var driver:Driver = new Driver(entry.id, entry.name, 
            entry.last_name, entry.cnh, 
            new Customer(entry.customer_id, null, null, null, null),
            new Tracker(entry.tracker_id, null, null, null, null, null, null),
            entry.dt_cnh, entry.dt_admission, entry.personal_phone, entry.coorp_phone,
            entry.address_street, 
            entry.address_number, 
            entry.address_complement, 
            entry.address_neighborhood,
            entry.address_city, 
            entry.address_state, 
            entry.address_country, 
            entry.address_zipcode, 
            entry.address_lat,
            entry.address_lng);
        
        driver.logisticCostKm = entry.logistic_cost_km;
        driver.logisticCostWeight = entry.logistic_cost_weight;

        var collaboratorType = new CollaboratorType(entry.collaborator_type_id, entry.collaborator_type_name);
        driver.collaboratorType = collaboratorType;

        return driver;
    }

    deleteDriver(tokenLogged:string, driver:Driver) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.driverUrl + '/deactivate', driver, {headers: headers})
                    .map(this.deleteDriverExtractFromJSON)
                    .catch(this.handleError);
        
        
    }

    private deleteDriverExtractFromJSON(res: Response | any) {
        //console.log('Excluído');
        let body = res.json();
        let entry = body[0];
        //console.log('res -> ' + entry);

    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            
            //errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            errMsg = body.detail || 'Ocorreu um erro no servidor.';
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }

    static generateDate(formatDate:any):Date {
        if (formatDate && formatDate.length > 0) {
            var dd = +formatDate.slice(8,10);
            var mm = +formatDate.slice(5,7);
            var yyyy = +formatDate.slice(0,4);
            var auxDate = new Date();
            auxDate.setDate(dd);
            auxDate.setMonth(mm-1);
            auxDate.setFullYear(yyyy);

            return auxDate;
        } else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/driver.service.ts